import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSetPlayerSelfExclusion = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetPlayerSelfExclusionRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.ISetPlayerSelfExclusionRequestData, TServerSendResponse>({
            ID: 35631,
            responses: [35632, 35633],
            description: 'Set player self-exclusion',
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
